import {
    ChangeDetectionStrategy,
    Component,
    ViewChild,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
    enumMapper,
    IMachine,
    MachineType,
    ModalResultType,
} from '@models';
import {
    encodeFilters,
    GRID_SERVICE,
    ODataGridComponent,
    STATE_HANDLER,
    urlStateHandler,
} from '@pages/generics/grid';
import { MachineService } from '@services';

import { BehaviorSubject } from 'rxjs';
import {
    finalize,
} from 'rxjs/operators';

import {
    MachineModalComponent,
    MachineRobotVersionsModalComponent,
} from './modals';

@Component({
    templateUrl: 'machines.page.html',
    providers: [{
        provide: GRID_SERVICE,
        useClass: MachineService,
    },
    {
        provide: STATE_HANDLER,
        useValue: urlStateHandler,
    }],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MachinesPageComponent extends ODataGridComponent<IMachine, number>  {

    public encodeFilters = encodeFilters;

    public MachineType = MachineType;

    public machineList = enumMapper(MachineType, {
        resourceKey: 'MachineType',
    });

    public loadingModal$ = new BehaviorSubject(false);

    @ViewChild('defaultMenuOption', { static: false })
    public defaultMenuOption?: MatButton;

    public isMachinesCreateGranted$ = this._appState.user.permissions.isGranted('Machines.Create');

    private _machineService = this._service as MachineService;

    public removeIems(items?: Array<IMachine>) {
        const toDelete = items || this._grid.selectionManager.selected;

        if (
            toDelete &&
            toDelete.length === 1
        ) {
            super.removeItems(toDelete);
            return;
        }

        const itemsIds = toDelete.map(machine => machine.id);

        this._modal.onConfirm(
            null,
            () => {
                this.loading$.next(true);
                this._machineService.deleteBulk(itemsIds)
                    .pipe(
                        finalize(() => this.loading$.next(false)),
                    )
                    .subscribe(() => this._refresh$.next());
            },
            () => { },
            this._translate.instant('grid_action_delete_message'));
    }

    async openModal(type: MachineType, model?: IMachine) {
        if (model) {
            this.loadingModal$.next(true);

            try {
                // retrieve the machine key, which is not yet available
                model = await this._machineService
                    .getInstance(model.id)
                    .toPromise();

                type = MachineType[model.type];
            } catch {
                this.loadingModal$.next(false);
                return;
            }
        }

        this.loadingModal$.next(false);
        this._modal
            .openModal(MachineModalComponent, model, {
                autoFocus: false,
                data: {
                    type,
                },
            })
            .afterClosedResult()
            .subscribe(res => {
                switch (res.type) {
                    case ModalResultType.Add:
                    case ModalResultType.Update:
                        this._refresh$.next();
                        break;
                }
            });
    }

    openVersionsModal(machine: IMachine) {
        this._modal
            .openModal(MachineRobotVersionsModalComponent, machine, {
                autoFocus: false,
            });
    }

    public getMachineNameSuggest(entry: IMachine) {
        return JSON.stringify([
            entry.id,
            entry.name,
        ]);
    }
}
